import { Schema } from '@bingads-webui-react/overreact';

import { edm } from './edm';

const schemaToModelMapping = {
  customer: 'Model/McaCustomer',
  social_profile: 'Model/SocialProfile',
  post: 'Model/Post',
  activity: 'Model/Activity',
  channel_user: 'Model/ChannelUser',
  campaign: 'Model/McaCampaign',
  ad: 'Model/McaAd',
  target: 'Model/Target',
  mca_location: 'Model/McaLocation',
  channel_profile: 'Model/ChannelProfile',
  tag: 'Model/McaTag',
  goal: 'Model/McaGoal',
  keyword: 'Model/McaKeyword',
  target_action: 'Model/TargetAction',
  subscription_plan: 'Model/SubscriptionPlan',
  account: 'Model/McaAccount',
  listings_mapping: 'Model/ListingsMapping',
  bing_user: 'Model/BingUser',
  facebook_page: 'Model/FacebookPage',
  facebook_user: 'Model/FacebookUser',
  google_user: 'Model/GoogleUser',
  instagram_user: 'Model/InstagramUser',
  linked_in_user: 'Model/LinkedInUser',
  twitter_user: 'Model/TwitterUser',
  bing_places_review: 'Model/BingPlacesReview',
  facebook_comment: 'Model/FacebookComment',
  facebook_conversation_thread: 'Model/FacebookConversationThread',
  facebook_post: 'Model/FacebookPost',
  facebook_review: 'Model/FacebookReview',
  facebook_wall_post: 'Model/FacebookWallPost',
  google_my_business_question: 'Model/GoogleMyBusinessQuestion',
  question_answer: 'Model/QuestionAnswer',
  google_my_business_review: 'Model/GoogleMyBusinessReview',
  instagram_comment: 'Model/InstagramComment',
  instagram_post: 'Model/InstagramPost',
  linked_in_comment: 'Model/LinkedInComment',
  linked_in_share: 'Model/LinkedInShare',
  tweet_activity: 'Model/TweetActivity',
  tweet: 'Model/Tweet',
  twitter_mention: 'Model/TwitterMention',
  twitter_post: 'Model/TwitterPost',
  twitter_retweet: 'Model/TwitterRetweet',
  mca_destination_goal: 'Model/McaDestinationGoal',
  location_target: 'Model/LocationTarget',
  radius_target: 'Model/RadiusTarget',
  carousel_ad: 'Model/CarouselAd',
  image_ad: 'Model/ImageAd',
  search_ad: 'Model/SearchAd',
  video_ad: 'Model/VideoAd',
  metric: 'Model/Metric',
  comment_for_reply: 'Model/CommentForReply',
  message_for_reply: 'Model/MessageForReply',
  url_preview_result: 'Model/UrlPreviewResult',
  o_auth_tokens: 'Model/OAuthTokens',
  ad_auto_complete: 'Model/AdAutoComplete',
  offline_ad_identity: 'Model/OfflineAdIdentity',
  mca_conversion_metric: 'Model/McaConversionMetric',
  mca_search_term_metric: 'Model/McaSearchTermMetric',
  mca_ad_metric: 'Model/McaAdMetric',
  fb_ad_account: 'Model/FbAdAccount',
  set_mca_goal_result: 'Model/SetMcaGoalResult',
  suggest_budget_response: 'Model/SuggestBudgetResponse',
  address: 'Model/Address',
  ad_source: 'Model/AdSource',
  mca_category: 'Model/McaCategory',
  mca_keyword_recommendations_response: 'Model/McaKeywordRecommendationsResponse',
  mca_target_recommendation: 'Model/McaTargetRecommendation',
  audience_reach_estimations_response: 'Model/AudienceReachEstimationsResponse',
  blob: 'Model/Blob',
  mca_ad_metric_set: 'Model/McaAdMetricSet',
  mca_alert_information: 'Model/McaAlertInformation',
  mca_conversion_metric_set: 'Model/McaConversionMetricSet',
  review_reply: 'Model/ReviewReply',
  media: 'Model/Media',
  attachment: 'Model/Attachment',
  media_attachment: 'Model/MediaAttachment',
  file_attachment: 'Model/FileAttachment',
  channel_data: 'Model/ChannelData',
  posting_status: 'Model/PostingStatus',
  mca_api_error: 'Model/McaApiError',
  mca_editorial_error: 'Model/McaEditorialError',
  editorial_info: 'Model/EditorialInfo',
  mca_editorial_reason: 'Model/McaEditorialReason',
  geo_point: 'Model/GeoPoint',
  mca_business_listing: 'Model/McaBusinessListing',
  channel_appeal_info: 'Model/ChannelAppealInfo',
  budget: 'Model/Budget',
  internal_info: 'Model/InternalInfo',
  ad_suggestion: 'Model/AdSuggestion',
  site_word: 'Model/SiteWord',
  uri: 'Model/Uri',
  mca_keyword_recommendation: 'Model/McaKeywordRecommendation',
  mca_location_target_recommendation: 'Model/McaLocationTargetRecommendation',
  mca_radius_target_recommendation: 'Model/McaRadiusTargetRecommendation',
  clarity_event_info: 'Model/ClarityEventInfo',
  disapproved_campaign: 'Model/McaCampaign',
  load_calendar: 'LoadCalendar',
  load_social_metrics: 'LoadSocialMetrics',
  get_u_p_budget_suggestions: 'GetUPBudgetSuggestions',
  get_subscription_ads_budget_suggestions: 'GetSubscriptionAdsBudgetSuggestions',
  get_suggested_ads: 'GetSuggestedAds',
  get_activities_count: 'GetActivitiesCount',
  get_target_suggestions: 'GetTargetSuggestions',
  validate_url: 'ValidateUrl',
  get_mca_blob_upload_url: 'GetMcaBlobUploadUrl',
  submit_change_history_report_task: 'ChangeHistoryTask',
  poll_change_history_report: 'ChangeHistoryTaskStatus',
  dismiss_ad_suggestions: 'DismissAdSuggestions',
  get_image_suggestions: 'GetImageSuggestions',
  apply_target_actions: 'ApplyTargetActions',
  set_keywords: 'SetKeywords',
  delete_mca_channel_ads: 'DeleteMcaChannelAds',
  get_top_ads: 'GetTopAds',
  load_thread: 'LoadThread',
  load_conversation: 'LoadConversation',
  verify_fb_ad_account_status: 'VerifyFbAdAccountStatus',
  send_fb_ad_account_invitation: 'SendFbAdAccountInvitation',
  reply_as_comment: 'ReplyAsComment',
  reply_as_message: 'ReplyAsMessage',
  set_clarity_event_info: 'SetClarityEventInfo',

  // external environment schema, we need this map to handle side effect
  campaign_ids_with_esc_budget_landscape: 'campaign_ids_with_esc_budget_landscape',
};

export const schema = new Schema(
  schemaToModelMapping,
  name => edm.schema.schemas[name]
);
